import { render, staticRenderFns } from "./SocialAuth.vue?vue&type=template&id=666145d4&lang=pug&"
import script from "./SocialAuth.vue?vue&type=script&lang=js&"
export * from "./SocialAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports